const events = {};

exports.subscribe = (eventName, callback) => {
  if (!events[eventName]) {
    events[eventName] = new Set();
  }
  events[eventName].add(callback);
};

exports.unsubscribe = (eventName, callback) => {
  if (events[eventName]) {
    events[eventName].delete(callback);
  }
};

exports.emit = (eventName, payload) => {
  if (events[eventName]) {
    for (const callback of events[eventName]) {
      callback(payload);
    }
  }
};